import  {eXcell,__extends} from './eXcell';

var eXcell_ron = (function (_super) {
    __extends(eXcell_ron, _super);
    function eXcell_ron(a) {
        _super.call(this);
        this.cell = a;
        this.grid = this.cell.parentNode.grid;
    }
    eXcell_ron.prototype.edit = function () { };
    eXcell_ron.prototype.isDisabled = function () {
        return true;
    };
    eXcell_ron.prototype.getValue = function () {
        return this.cell._clearCell
            ? ""
            : this.cell._orig_value ||
                this.grid
                    ._aplNFb(this.cell.innerHTML.toString()._dhx_trim(), this.cell._cellIndex)
                    .toString();
    };
    return eXcell_ron;
})(eXcell);
eXcell_ron.prototype.setValue = function (a) {
    if (a !== 0) {
        if (!a || a.toString()._dhx_trim() == "") {
            this.setCValue("&nbsp;");
            return (this.cell._clearCell = true);
        }
    }
    this.cell._orig_value = a;
    this.cell._clearCell = false;
    this.setCValue(a ? this.grid._aplNF(a, this.cell._cellIndex) : "0");
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_ron.js